<script>
  import { format } from 'svelte-i18n';
  import Select from 'svelte-select';

  import { Spinner } from '@client/components/spinner';

  export let items = [];
  export let filterText;
  export let itemFilter = (label, filterText, option) => `${label}`.toLowerCase().includes(filterText.toLowerCase());
  export let value = null;
  export let loading = false;
</script>

<span class="styled">
  {#if loading}
    <div
      id={$$restProps.id}
      class="select-loading {$$restProps.class || ''}"
      data-testid="select-loading"
      aria-busy="true"
    >
      <Spinner show inline />
    </div>
  {:else}
    <Select
      {...$$restProps}
      placeholderAlwaysShow
      on:blur
      on:change
      on:clear
      on:error
      on:filter
      on:focus
      on:input
      on:loaded
      on:remove
      bind:value
      bind:items
      bind:filterText
      {itemFilter}
      autocomplete="off"
    >
      <slot slot="selection" name="selection" let:selection {selection} let:index {index}>
        <span data-testid="selected-item" class="selection">
          {selection.label}
        </span>
      </slot>
      <slot name="item" slot="item" let:item {item}>
        {$format(item.label)}
      </slot>
      <slot name="empty" slot="empty">
        <div class="empty">{$format('label.NO_OPTIONS_AVAILABLE')}</div>
      </slot>
    </Select>
  {/if}
</span>

<style lang="scss" src="./select.scss"></style>
